//implementacion de ngxdatatable
//https://stackoverflow.com/questions/51303630/how-to-use-edit-and-delete-options-in-angular-ngx-datatables

//solucion para usar metodos de angular en html
//https://stackblitz.com/edit/angular-c6vfcq?file=src%2Fapp%2Fapp.component.html

//solución al asignar el input date 
//https://stackblitz.com/edit/angular-xuvrtq?file=src%2Fapp%2Fapp.component.ts

import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { DatatableComponent } from '@swimlane/ngx-datatable';
import { EmptyError } from 'rxjs';
import { UsuarioService } from '../../services/usuario.service';
import { Terminal } from '../../models/terminal';
import { Sucursal } from '../../models/sucursal';
import { Equipo } from '../../models/equipo';
import { SucursalService } from '../../services/sucursal.service';
import { TerminalService } from '../../services/terminal.service';
import { EquipoService } from '../../services/equipo.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var $:any;

@Component({
    selector:'admin-equipo',
    templateUrl:'./admin-equipo.component.html',
    providers:[UsuarioService,SucursalService,TerminalService,EquipoService],
    //styleUrls:['../']
})

export class AdminEquipoComponent implements OnInit{
    @ViewChild('addForm') formValues:NgForm; //added this
    public title:string;
    public terminal_:Terminal;
    public equipo:Equipo;
    public status:string;
    public errorTexto:string;
    fromDate;

    public sucursales : Sucursal[];
    public terminales: any[];

    public token;

    editing = {};
    rows = [];
    columns = [];
    selected=[];
    temp = [];

    loadingIndicator:boolean = true;
    reaorderable: boolean = true;

    @ViewChild(DatatableComponent) table: DatatableComponent;

    constructor(
        private _usuarioService: UsuarioService,
        private _sucursalservice: SucursalService,
        private _terminalservice:TerminalService,
        private _equiposervice:EquipoService
    ){
        this.title = 'Catálogo de equipos';
        this.token = this._usuarioService.getToken();
        this.inicializarClase();
        this.GRIDlistar();
}

/**
 * Métodos
 */

 inicializarClase(){
    this.equipo = new Equipo();
    this.equipo.ID = 0;
    this.equipo.DESCRIPCION = "";
    this.equipo.NUM_SERIE = "";
    this.equipo.ESTATUS = true;
    return this.equipo;
 }

ngOnInit(){
    console.log('Componente admin-equipo cargado');
    this.obtenerSucursales(this.token);
    this.token = this._usuarioService.getToken();

    this.columns = [
        { Name:'ID',prop: 'ID'},
        { name:'DESCRIPCIÓN', prop: 'DESCRIPCION'},
        { name:'# SERIE', prop: 'NUM_SERIE' },
        { name:'TERMINAL', prop: 'Terminal.DESCRIPCION' },
        { name:'SUCURSAL', prop: 'Sucursal.DESCRIPCION' },
        { name:'ESTATUS', prop:'estatus_texto'}
    ]
}

obtenerSucursales(token){
    this._sucursalservice.obtenerSucursalesActivas(token).subscribe(
        response =>{
            this.sucursales = response.items;
        },
        err=>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error'; 
            }
        }
    )
}

btn_nuevo(){
    this.inicializarClase();
    this.selectedValue= this.sucursales[0];
    this.doSomething('nuevo');
    $('#exampleModal').modal('show');
}

selectedValue: any;
selectedValueTerminal: any;
doSomething(valor) {
    console.log(this.selectedValue);
    this.equipo.Sucursal = this.selectedValue;
    this.obtenerTerminalesPorSucursal(this.equipo.Sucursal.ID,this.token,valor);
    //this.terminales = this._terminalservice.obtenerActivas(this.equipo.Sucursal.ID,this.token);
}// setNewUser()

doSomethingTerminal() {
    console.log(this.selectedValueTerminal);
    this.equipo.Terminal = this.selectedValueTerminal;
    //this.obtenerTerminalesPorSucursal(this.equipo.Sucursal.ID,this.token);
}// setNewUser()

obtenerTerminalesPorSucursal(ID_SUCURSAL:number,token:string,valor:string){
    this._terminalservice.obtenerActivas(ID_SUCURSAL,token).subscribe(
        response =>{
            this.terminales = response.items;
            if(valor==='nuevo' || valor=='seleccion'){
                this.selectedValueTerminal=this.terminales[0];
            }else{
                this.selectedValueTerminal = this.terminales.find(x => x.ID === this.equipo.ID_TERMINAL);
            }
            this.equipo.Terminal = this.selectedValueTerminal;
        },
        err=>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error';
            }
        }
    )
}

GRIDlistar(){
    this._equiposervice.GRIDlistar(this.token).subscribe(
        response =>{
            this.rows = response.items;
            this.temp = response.items;
        },
        err =>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error';
            }
        }
    );
}

    /*onSelect({ selected }) {
        console.log('Select Event', selected, this.selected);
      }*/
    
    onActivate(event) {
    if(event.type == 'click') {
        this.status = "";
        this.equipo = event.row;
        this.selectedValue = this.sucursales.find(x => x.ID === this.equipo.ID_SUCURSAL);
        this.doSomething('modificacion');
        /*this.doSomething();
        this.selectedValueTerminal = this.terminales.find(x => x.ID === this.equipo.ID_TERMINAL);*/
        $('#exampleModal').modal('show');
    }
}

obtenerPorId(ID,token){
    this._terminalservice.terminalBuscarPorId(ID,token).subscribe(
        response =>{
            this.equipo = response.item;
            $('#exampleModal').modal('show');
        },
        err=>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error';
            }
        }
    )
}

onSubmit(){
    this.equipo.FEC_REG = new Date();
    this.equipo.HHMMSS_MOD = new Date();
    console.log("log de onsubmit: " + JSON.stringify(this.equipo));
    this._equiposervice.gestion(this.equipo,this.token).subscribe(
        response =>{
            $('#txtBuscar').val('');
            this.GRIDlistar();
            this.formValues.resetForm(); // Added this
            this.status = "";
            $('#exampleModal').modal('hide');
        },
        err =>{
            var errorMessage = <any>err;
            console.log('respuesta del servidor (error): ' + JSON.stringify(errorMessage.error.message));
            this.errorTexto = errorMessage.error.message;
            if(errorMessage !=null){
                this.status = 'error';
            }
        }
    );
}

updateFilter(event) {
    const val = event.target.value.toLowerCase();   
    // filter our data
    const temp = this.temp.filter(function(d) {
        return d.DESCRIPCION.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
}
}